import React from 'react'
import { gql, useMutation, useQuery } from '@apollo/client'
import { toast } from 'react-toastify'
import { message } from 'antd'
import Papa from 'papaparse'
import { useLoading } from '../../context/useLoading'
import ContentAudios from './ContentAudios'
import WithMainLayout from '../../hocs/withMainLayout'
import Loading from '../shared/Loading'

const GET_CONTENTAUDIOS = gql`
  query statusedTales {
    statusedTales {
      id
      title
      authors {
        id
        name
      }
      voiceActors {
        id
        name
      }
      tags {
        id
        nameKZ
        nameRU
        nameEN
      }
      ageGroup
      publisher {
        id
        name
      }
      link2Audio
      link2Text
      coverImage
      descriptionKZ
      descriptionRU
      descriptionEN
      status
      lyrics
      restrictions
    }
  }
`

const ADD_CONTENTAUDIO = gql`
  mutation addContentAudio(
    $audiofile: FileUpload!
    $textfile: FileUpload
    $coverImageFile: FileUpload
    $input: ContentAudioInput
  ) {
    addContentAudio(
      audiofile: $audiofile
      textfile: $textfile
      coverImageFile: $coverImageFile
      input: $input
    ) {
      id
      title
      authors {
        id
        name
      }
      voiceActors {
        id
        name
      }
      tags {
        id
        nameKZ
        nameRU
        nameEN
      }
      ageGroup
      publisher {
        id
        name
      }
      link2Audio
      link2Text
      coverImage
      descriptionKZ
      descriptionRU
      descriptionEN
      status
      lyrics
      restrictions
    }
  }
`

const UPDATE_CONTENTAUDIO = gql`
  mutation updateContentAudio(
    $id: ID!
    $audiofile: FileUpload
    $textfile: FileUpload
    $coverImageFile: FileUpload
    $input: UpdateContentAudioInput
  ) {
    updateContentAudio(
      id: $id
      audiofile: $audiofile
      textfile: $textfile
      coverImageFile: $coverImageFile
      input: $input
    ) {
      id
      title
      authors {
        id
        name
      }
      voiceActors {
        id
        name
      }
      tags {
        id
        nameKZ
        nameRU
        nameEN
      }
      ageGroup
      publisher {
        id
        name
      }
      link2Audio
      link2Text
      coverImage
      descriptionKZ
      descriptionRU
      descriptionEN
      status
      lyrics
      restrictions
    }
  }
`

const DELETE_CONTENTAUDIO = gql`
  mutation updateContentAudio($id: ID!, $input: UpdateContentAudioInput) {
    updateContentAudio(id: $id, input: $input) {
      id
      title
      authors {
        id
        name
      }
      voiceActors {
        id
        name
      }
      tags {
        id
        nameKZ
        nameRU
        nameEN
      }
      ageGroup
      publisher {
        id
        name
      }
      link2Audio
      link2Text
      coverImage
      descriptionKZ
      descriptionRU
      descriptionEN
      status
      lyrics
    }
  }
`

// const DELETE_CONTENTAUDIO = gql`
//   mutation deleteContentAudio($id: ID!) {
//     deleteContentAudio(id: $id) {
//       id
//       message
//     }
//   }
// `

const GET_CREATORS = gql`
  query creators {
    creators {
      id
      name
      photo
    }
  }
`

const GET_PUBLISHERS = gql`
  query publishers {
    publishers {
      id
      name
    }
  }
`

const GET_TAGS = gql`
  query tags {
    tags {
      id
      nameKZ
      nameRU
      nameEN
    }
  }
`

const ContentAudiosContainer = () => {
  const { showLoading, hideLoading } = useLoading()
  const [allContentAudios, setAllContentAudios] = React.useState([])
  const { data, loading, error, refetch } = useQuery(GET_CONTENTAUDIOS)
  const { data: allTags, loading: tagsLoading } = useQuery(GET_TAGS)
  const { data: allCreators, loading: creatorsLoading } = useQuery(GET_CREATORS)
  const { data: allPublishers, loading: publishersLoading } = useQuery(
    GET_PUBLISHERS
  )

  const [addContentAudio, { error: errorAddContentAudio }] = useMutation(
    ADD_CONTENTAUDIO,
    {
      update(cache, { data: { addContentAudio: addContentAudioItem } }) {
        const { statusedTales } = cache.readQuery({ query: GET_CONTENTAUDIOS })
        cache.writeQuery({
          query: GET_CONTENTAUDIOS,
          data: { statusedTales: [addContentAudioItem].concat(statusedTales) }
        })
        hideLoading()
        toast.success('Аудио добавлено')
      }
    }
  )
  const [updateContentAudio, { data: updateContentAudioData }] = useMutation(
    UPDATE_CONTENTAUDIO
  )
  const [deleteContentAudio, { error: errorDeleteContentAudio }] = useMutation(
    DELETE_CONTENTAUDIO,
    {
      update(cache, { data: { updateContentAudio: deleteContentAudioItem } }) {
        const { statusedTales } = cache.readQuery({ query: GET_CONTENTAUDIOS })
        cache.writeQuery({
          query: GET_CONTENTAUDIOS,
          data: {
            statusedTales: statusedTales.filter(
              contentAudio => contentAudio.id !== deleteContentAudioItem.id
            )
          }
        })
        hideLoading()
        toast.success('Аудио удалено')
      }
    }
  )

  React.useEffect(() => {
    if (errorAddContentAudio) {
      console.log(errorAddContentAudio)
    }
  }, [errorAddContentAudio])

  React.useEffect(() => {
    if (errorDeleteContentAudio) {
      console.log(errorDeleteContentAudio)
    }
  }, [errorDeleteContentAudio])

  React.useEffect(() => {
    if (
      data &&
      !error &&
      !loading &&
      !creatorsLoading &&
      !tagsLoading &&
      !publishersLoading
    ) {
      setAllContentAudios(data.statusedTales)
    }
  }, [
    data,
    loading,
    error,
    updateContentAudioData,
    creatorsLoading,
    tagsLoading,
    publishersLoading
  ])

  function csv2StringParser(file) {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        complete(results, file) {
          try {
            const obj = {}
            results.data.map(item => {
              if (item.Time) obj[Number(item.Time.trim())] = item.Text.trim()
            })
            if (Object.keys(obj).length === 0) {
              message.error('Невозможно обработать текстовый файл')
              resolve(-1)
            }
            resolve(JSON.stringify(obj))
          } catch {
            message.error('Невозможно обработать текстовый файл')
            resolve(-1)
          }
        },
        error(err, file) {
          message.error('Невозможно обработать текстовый файл')
          console.log(err)
          resolve(-1)
        }
      })
    })
  }

  const addContentAudioHandler = async (
    form,
    closeFunc,
    audiofile,
    textfile,
    coverImageFile,
    setAudioFile,
    setTextFile,
    setCoverImageFile,
    audioFileRef,
    textFileRef,
    coverImageFileRef
  ) => {
    showLoading()

    let lyrics
    if (textfile) lyrics = await csv2StringParser(textfile)
    // console.log('lyrics', lyrics)
    lyrics !== -1
      ? form
          .validateFields()
          .then(val => {
            form.resetFields()
            addContentAudio({
              variables: {
                audiofile: audiofile,
                coverImageFile,
                input: {
                  type: 'tale',
                  title: val.title,
                  authors: val.authors,
                  voiceActors: val.voiceActors ? val.voiceActors : [],
                  publisher: val.publisher ? val.publisher : null,
                  tags: val.tags ? val.tags : [],
                  ageGroup: val.ageGroup ? val.ageGroup : null,
                  descriptionKZ: val.descriptionKZ,
                  descriptionRU: val.descriptionRU,
                  descriptionEN: val.descriptionEN,
                  status: val.status,
                  lyrics: lyrics ? lyrics : val.lyrics
                }
              }
            })
          })
          .then(() => {
            setAudioFile(null)
            setTextFile(null)
            setCoverImageFile(null)
            audioFileRef.current.value = null
            textFileRef.current.value = null
            coverImageFileRef.current.value = null
            closeFunc(false)
          })
      : hideLoading()
  }

  const updateContentAudioHandler = async (
    form,
    contentAudioId,
    closeFunc,
    audiofile,
    textfile,
    coverImageFile,
    setAudioFile,
    setTextFile,
    setCoverImageFile,
    audioFileRef,
    textFileRef,
    coverImageFileRef
  ) => {
    showLoading()
    let lyrics
    if (textfile) lyrics = await csv2StringParser(textfile)
    // console.log('lyrics', lyrics)
    lyrics !== -1
      ? form
          .validateFields()
          .then(val => {
            // console.log('upd vals', val)
            updateContentAudio({
              variables: {
                id: contentAudioId,
                audiofile,
                coverImageFile,
                input: {
                  title: val.title,
                  authors: val.authors,
                  voiceActors: val.voiceActors ? val.voiceActors : [],
                  publisher: val.publisher ? val.publisher : null,
                  tags: val.tags ? val.tags : [],
                  ageGroup: val.ageGroup ? val.ageGroup : null,
                  descriptionKZ: val.descriptionKZ,
                  descriptionRU: val.descriptionRU,
                  descriptionEN: val.descriptionEN,
                  status: val.status,
                  lyrics: lyrics ? lyrics : val.lyrics,
                  restrictions: val.restrictions
                }
              }
            })
          })
          .then(() => {
            hideLoading()

            setAudioFile(null)
            setTextFile(null)
            setCoverImageFile(null)
            audioFileRef.current.value = null
            textFileRef.current.value = null
            coverImageFileRef.current.value = null
            closeFunc(false)
            toast.success('Аудио обновлено')
          })
      : hideLoading()
  }

  const deleteContentAudioHandler = (contentAudioId, closeFunc) => {
    showLoading()
    deleteContentAudio({
      variables: {
        id: contentAudioId,
        input: {
          status: 'deleted'
        }
      }
    }).then(() => {
      // console.log("data ", deleteContentAudioData)
      // hideLoading()
      closeFunc(false)
    })
  }

  const removeFilesHandler = (contentAudioId, textFile, coverImage) => {
    // console.log('id', contentAudioId)
    // console.log('textFile', textFile)
    // console.log('coverImage', coverImage)
    updateContentAudio({
      variables: {
        id: contentAudioId,
        input: textFile
          ? {
              link2Text: null
            }
          : {
              coverImage: null
            }
      }
    }).then(() => {
      toast.success('Песня обновлена')
    })
  }

  if (loading || creatorsLoading || tagsLoading || publishersLoading) {
    return <Loading />
  }

  return (
    <ContentAudios
      contentAudios={allContentAudios}
      allCreators={allCreators}
      allPublishers={allPublishers}
      allTags={allTags}
      addContentAudio={addContentAudio}
      refetch={refetch}
      addContentAudioHandler={addContentAudioHandler}
      updateContentAudioHandler={updateContentAudioHandler}
      deleteContentAudioHandler={deleteContentAudioHandler}
      removeFilesHandler={removeFilesHandler}
    />
  )
}

export default WithMainLayout(ContentAudiosContainer)
